import { classNames } from "@circle-react/helpers/twMergeWithCN";
import type { PropsWithChildren } from "react";

interface PaywallDetailContainer {
  className?: string;
}

export const PaywallDetailContainer = ({
  children,
  className,
}: PropsWithChildren<PaywallDetailContainer>) => (
  <div
    className={classNames("flex flex-col gap-3", className)}
    data-testid="checkout-paywall-detail"
  >
    {children}
  </div>
);
